@if (MessagesInfo$ | async; as info) {
  @if (info.hasMessages) {
    <li class="menu-item" (click)="toggleMessages($event)" (keydown.enter)="toggleMessages($event)" tabindex="0">
      <div class="menu-item-content">
        <i class="fa-regular fa-envelope"></i>
        <span>Mes messages</span>

        <div class="badge-and-caret">
          <app-badge [badgeValue]="info.count" [isWhite]="true"></app-badge>

          <i [ngClass]="isMessagesOpen ? 'fa-solid fa-caret-up' : 'fa-solid fa-caret-down'" class="caret-icon"></i>
        </div>
      </div>
    </li>

    @if (isMessagesOpen) {
      <li class="sub-menu">
        @for (activity of info.messageNotifications; track activity.activityId) {
          <li
            class="sub-menu-item"
            (click)="navigateToActivityMessages(activity.activityId)"
            (keydown.enter)="navigateToActivityMessages(activity.activityId)"
            tabindex="0">
            <div class="sub-menu-item-content">
              {{ activity.activityTitle }}
              <app-badge [badgeValue]="activity.countMessagesNotRead"></app-badge>
            </div>
          </li>
        }
      </li>
    }
  } @else {
    <li class="menu-item disabled" tabindex="-1">
      <div class="menu-item-content">
        <i class="fa-regular fa-envelope"></i>
        <span>Mes messages</span>
      </div>
    </li>
  }
}
